import React from "react";
import S from "./Logos.styled";
import { IWPImage, IWPLink } from "@/src/types";
import { gatsbyImageHelper } from "@/src/helpers";
import Marquee from "react-fast-marquee";
import { motion } from "framer-motion";
import { motionAnimation } from "@/styles/global";

export interface LogosProps {
  blockId: string;
  logos: { link?: IWPLink; logo: IWPImage }[];
}

const Logos: React.FC<LogosProps> = ({ logos, blockId = "" }) => {
  const renderLogos = logos.map(({ link, logo }, index) => {
    const key = `logo-${index}`;
    const logoData = gatsbyImageHelper(logo);

    const renderLogo = () => {
      return (
        <>
          {logoData && (
            <S.Logo
              image={logoData}
              alt={logo.altText}
              objectFit="contain"
              loading="eager"
            />
          )}
        </>
      );
    };

    return (
      <React.Fragment key={key}>
        {link ? (
          <>
            {link.target === "_blank" ? (
              <S.LogoLink target={link.target} href={link.url}>
                {renderLogo()}
              </S.LogoLink>
            ) : (
              <S.LogoLinkInternal to={link.url}>
                {renderLogo()}
              </S.LogoLinkInternal>
            )}
          </>
        ) : (
          <S.LogoWrapper>{renderLogo()}</S.LogoWrapper>
        )}
      </React.Fragment>
    );
  });
  return (
    <S.Section id={blockId} as={motion.section} {...motionAnimation}>
      <div>
        <Marquee
          speed={40}
          pauseOnHover
          autoFill
          gradient
          gradientWidth={"20%"}
        >
          {renderLogos}
        </Marquee>
      </div>
    </S.Section>
  );
};

export default Logos;
